import styled, { css } from 'styled-components';
import { Tab, TabPanel, Tabs, Button } from '@tryhackme/thm-ui-components';

export const StyledCommon = css`
  margin-top: 3rem;
`;
export const StyledComplexRoomBox = styled.div<{ $splitScreenOpen: boolean }>`
  padding: 1.8rem 3rem 3rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  margin-bottom: 3rem;
  border-radius: ${({ theme }) => theme.radius.small};
  overflow-x: auto;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 3rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 3rem 1.8rem;
  }

  ${({ $splitScreenOpen }) =>
    $splitScreenOpen &&
    css`
      padding: 3rem 1.8rem;
    `}
`;

export const StyledTabsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledTabs = styled(Tabs)<{ $splitScreenOpen: boolean }>`
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }

  ${({ $splitScreenOpen }) =>
    $splitScreenOpen &&
    css`
      display: none;
    `}
`;

export const StyledTab = styled(Tab)`
  svg {
    margin-right: 0.6rem;
  }
`;

export const StyledSearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 30rem;
`;

export const StyledClearButton = styled(Button)`
  svg {
    height: 1.9rem;
    width: 1.9rem;
    color: ${({ theme }) => theme.colors.grey[700]};
  }
`;

export const StyledViewWrapper = styled.div`
  ${StyledCommon};
`;

export const StyledTabPanel = styled(TabPanel)`
  ${StyledCommon};
`;

export const StyledSelect = styled.div<{ $splitScreenOpen: boolean }>`
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
    overflow: hidden;
  }

  ${({ $splitScreenOpen }) =>
    $splitScreenOpen &&
    css`
      display: block;
    `}
`;
